var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-layout flex justify-between items-start text-base tracking-normal md_text-2xl font-serif px-17 py-12 md_px-20 md_py-16"},[_vm._t("title"),_vm._t("button")],2)}
var staticRenderFns = []

export { render, staticRenderFns }